import type { Components, Theme } from '@mui/material';

export const MuiTab: Components<Omit<Theme, 'components'>>['MuiTab'] = {
  styleOverrides: {
    root: {
      textTransform: 'none',
      minHeight: '42px',
      maxHeight: '42px',
      height: '42px',
      ['&.Mui-selected']: {
        color: '#0D1B27DE',
      },
    },
  },
};
